// extracted by mini-css-extract-plugin
module.exports = {"root":"_b36f3d","header":"_7ca41e","itemsList":"_25440c","item":"_8edd8e","active":"_bc0fa3"};